<script setup lang="ts">
import { computed } from 'vue';
import { jwtHasPermission, type ApiAudience } from '@botto/core';
import { menuStore } from '@/layout/menu';

const sections = computed(() =>
  menuStore.visibleSections
    .map((s) => ({
      ...s,
      items: s.items.filter((i) => {
        if (i.hidden) return false;
        if (i.requiresPermission) {
          return jwtHasPermission(s.id as ApiAudience, i.requiresPermission);
        }
        return true;
      }),
    }))
    .filter((s) => s.items.length > 0),
);
</script>

<template>
  <div class="home">
    <h1 class="home__title">
      SMPP Router<span class="botto-brand__mvp">MVP</span>
    </h1>
    <p class="home__sub">Единая админ-панель. Показаны только доступные вам разделы.</p>
    <div class="home__grid">
      <section v-for="s in sections" :key="s.id" class="home__card">
        <h2>{{ s.title }}</h2>
        <ul>
          <li v-for="item in s.items" :key="item.title">
            <RouterLink :to="(item.to as any)">{{ item.title }}</RouterLink>
          </li>
        </ul>
      </section>
    </div>
  </div>
</template>

<style scoped>
.home { padding: 24px; }
.home__title { margin: 0 0 8px; font-size: 28px; font-weight: 600; letter-spacing: -0.02em; }
.home__sub { color: #666; margin-bottom: 24px; }
.home__grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)); gap: 16px; }
.home__card { padding: 16px; border: 1px solid var(--dx-color-border, #e0e0e0); border-radius: 6px; background: #fff; }
.home__card h2 { margin-top: 0; font-size: 16px; }
.home__card ul { padding-left: 18px; margin: 8px 0 0; }
</style>
